module.exports = __webpack_public_path__ + "img/project_5.f0edc4ff.png";